/**
 * Centralized stock image URLs for the landing page.
 *
 * Uses Unsplash source URLs with relevant insurance/health search terms.
 * Hero images use higher resolution; card images use smaller dimensions.
 *
 * @module landing/content/images
 */

export const LANDING_IMAGES = {
  hero: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=80',
  medical: 'https://images.unsplash.com/photo-1551076805-e1869033e561?w=600&q=80',
  dental: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=600&q=80',
  vision: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=600&q=80',
  pharmacy: 'https://images.unsplash.com/photo-1585435557343-3b092031a831?w=600&q=80',
} as const;
